<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="key" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'configKey', validatorRules.configKey]" placeholder="请输入key"></a-input>
        </a-form-item>
        <a-form-item label="值" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'configValue', validatorRules.configValue]" placeholder="请输入值"></a-input>
        </a-form-item>
        <a-form-item label="过滤项" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'configFilter', validatorRules.configFilter]" placeholder="请输入过滤项"></a-input>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['remark',{trigger:'input'}]"/>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JEditor from '@/components/jeecg/JEditor'

  export default {
    name: "BusDailyConfigModal",
    components: { 
      JEditor,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          configKey: {rules: [
            {required: true, message: '请输入key!'},
          ]},
          configValue: {rules: [
            {required: true, message: '请输入值!'},
          ]},
          configFilter: {rules: [
            {required: true, message: '请输入过滤项!'},
          ]},
          remark: {rules: [
          ]},
        },
        url: {
          add: "/dailyproject/busDailyConfig/add",
          edit: "/dailyproject/busDailyConfig/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'configKey','configValue','configFilter','remark'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'configKey','configValue','configFilter','remark'))
      },

      
    }
  }
</script>